const main = {
  // Page titles and welcome information
  policyRegulation: "Policy Regulation",
  blockchainKnowledge: "Blockchain Industry Knowledge",
  blockchainCaseInvestigation: "Blockchain Case Investigation Records",

  // Status messages
  loadingText: "Loading...",
  noDataText: "No Data Available",
};

// HelpHome page content
const helpHome = {
  helpCenterTitle: "Help Center",
  expertService: "Expert Service",
  productFunctionIntro: "Product Function Introduction",
};

// judgmentBookDocuments page content
const judgmentBookDocuments = {
  originalText: "Original Text",
};

// National-involvment page content
const nationalInvolvment = {
  // Page title
  judicialPrecedentTitle: "Judicial Precedent Reference",

  // Search form
  judgmentTitlePlaceholder: "Please enter document title",
  caseNumberPlaceholder: "Please enter case number",
  chargePlaceholder: "Please enter case cause",
  caseTypePlaceholder: "Please select case type",
  regionPlaceholder: "Please select (Province/City)",
  platformPlaceholder: "Please select platform",
  procedurePlaceholder: "Please select procedure",

  // Date picker
  dateRangeSeparator: "to",
  startDatePlaceholder: "Start Date",
  endDatePlaceholder: "End Date",

  // Buttons
  resetButton: "Reset",
  searchButton: "Search",

  // Status messages
  loadingText: "Loading...",
  noDataText: "No Data Available",

  // Case information labels
  caseTypeLabel: "Case Type",
  caseNumberLabel: "Case Number",
  chargeLabel: "Case Cause",
  regionLabel: "Region",
  platformLabel: "Involved Platform",
  currencyLabel: "Involved Currency",

  // Default options
  allCases: "All Cases",
  allProvinces: "All Provinces",
  allCities: "All Cities",
  allCurrencies: "All Currencies",
  allPlatforms: "All Platforms",
  allProcedures: "All Procedures",
};

// production-fun page content
const productionFun = {
  // Page title and description
  productFunctionIntro: "Product Function Introduction",
  productDescription:
    "The product takes virtual currency addresses as the entry point, with on-chain transaction traceability and anonymous identity resolution as the core, serving as a one-stop investigation and control platform for combating new types of virtual currency crimes, assisting law enforcement agencies in solving various data analysis, case breakdown, and analysis and judgment difficulties in virtual currency cases.",

  // Tabs
  productDemo: "Product Demo",
  analysisResearch: "Analysis & Research",
  evidenceManagement: "Evidence Management",
  dataDashboard: "Data Dashboard",

  // Function modules
  addressHashUserAnalysis: "Address, Hash, Evidence User Analysis",
  addressHashUserDesc:
    "One-click query of basic transaction data, balance and labels of addresses. Preliminary understanding of address transaction status and label attributes",
  demoVideo: "Demo Video",

  characterAnalysis: "Character Analysis",
  characterAnalysisDesc:
    "For parsed judicial evidence files, use character analysis ID search to easily access evidence file content and fully understand character account status",

  caseAnalysis: "Case Analysis",
  caseAnalysisDesc:
    "Create case canvas, graphically display on-chain transfer relationships, focus on related address fund flows, and deeply query address transaction details",
  demoVideoCaseManagement: "Demo Video - Case Management",
  demoVideoCanvasAnalysis: "Demo Video - Canvas Analysis",

  addressMonitoring: "Address Monitoring",
  addressMonitoringDesc:
    "Monitor specific addresses and notify on-chain transfer information in real-time, closely tracking address fund movements",

  aiModel: "AI Model",
  aiModelDesc:
    "Query transaction fee sources of involved addresses, quickly obtain real controller clues of addresses, facilitating further judicial evidence collection by investigators",

  labelManagement: "Label Management",
  labelManagementDesc:
    "Independent management of address labels, real-time synchronization to canvas, significantly improving analysis efficiency",

  evidenceSuggestion: "Evidence Suggestion",
  evidenceSuggestionDesc:
    "One-click generation and download of judicial evidence suggestion documents for major platforms, with detailed steps to make judicial evidence collection 'not lost'",

  evidenceUser: "Evidence User",
  evidenceUserDesc:
    "Comprehensive organization of evidence return files, immediate query and understanding of evidence results",

  evidenceUpload: "Evidence Upload",
  evidenceUploadDesc:
    "Support upload and parsing of evidence files from all mainstream exchanges. Use parsed character analysis IDs for direct analysis in case canvas, not only viewing character account details but also intuitively displaying character transfer relationships",

  transactionData: "Transaction Data",
  transactionDataDesc:
    "Case key address transaction data at a glance, case situation clear at a glance",

  balanceData: "Balance Data",
  balanceDataDesc:
    "Real-time update of case address balances, focusing on case value",
};

// prosecuteBook page content
const prosecuteBook = {
  // Page title
  indictmentTitle: "Indictment",

  // Search form
  titlePlaceholder: "Please enter document title",
  caseNumberPlaceholder: "Please enter case number",
  caseTypePlaceholder: "Please select case type",
  regionPlaceholder: "Please select (Province/City)",
  platformPlaceholder: "Please select platform",
  currencyPlaceholder: "Please select currency",

  // Date picker
  dateRangeSeparator: "to",
  startDatePlaceholder: "Start Date",
  endDatePlaceholder: "End Date",

  // Buttons
  resetButton: "Reset",
  searchButton: "Search",

  // Status messages
  loadingText: "Loading...",
  noDataText: "No Data Available",

  // Case information labels
  caseTypeLabel: "Case Type",
  caseNumberLabel: "Case Number",
  regionLabel: "Region",
  platformLabel: "Involved Platform",
  currencyLabel: "Involved Currency",

  // Default options
  allCases: "All Cases",
  allProvinces: "All Provinces",
  allCities: "All Cities",
  allCurrencies: "All Currencies",
  allPlatforms: "All Platforms",
  allProcedures: "All Procedures",
};

// ReferenceDocuments page content
const referenceDocuments = {
  // Status messages
  loadingText: "Loading...",

  // Document information labels
  courtLabel: "Court:",
  caseNumberLabel: "Case Number:",
  judgmentDateLabel: "Judgment Date:",
  chargeLabel: "Charge:",
  legalBasisLabel: "Legal Basis",
};

export default {
  ...main,
  ...helpHome,
  ...judgmentBookDocuments,
  ...nationalInvolvment,
  ...productionFun,
  ...prosecuteBook,
  ...referenceDocuments,
  // Sub-modules
};
